import { useQuery } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { IProFormaSourceTableRow } from '../types';

export const getProFormaSources = async (
    dealId: number,
    proFormaId: number,
): Promise<IProFormaSourceTableRow[]> => {
    const response = await axiosInstance.get(API_ENDPOINTS.PRO_FORMA_SOURCES(dealId, proFormaId));
    return response.data;
};

export const useGetProFormaSources = (
    dealId: number,
    proFormaId: number,
    options: { enabled: boolean, refetchOnMount?: boolean } = { enabled: true },
) => useQuery({
    queryKey: ['SourcesByProFormaId', dealId, proFormaId],
    queryFn: () => getProFormaSources(dealId, proFormaId),
    ...options,
});

export default useGetProFormaSources;
